import { getFirebaseBackend } from "../../authUtils.js";

export const state = {
  currentUser: sessionStorage.getItem("auth.currentUser")
    ? JSON.parse(sessionStorage.getItem("auth.currentUser"))
    : null,

  token: sessionStorage.getItem("auth.token") || null,
};

export const mutations = {
  SET_CURRENT_USER(state, newValue) {
    state.currentUser = newValue;
    sessionStorage.setItem("auth.currentUser", JSON.stringify(newValue));
  },

  SET_TOKEN(state, token) {
    state.token = token;
    window.sessionStorage.setItem("auth.token", token);
  },

  CLEAR_AUTH(state) {
    state.currentUser = null;
    state.token = null;
    sessionStorage.removeItem("auth.currentUser");
    sessionStorage.removeItem("auth.token");
    sessionStorage.removeItem("app_url");
    localStorage.removeItem("user");
  },
};

export const getters = {
  // Whether the user is currently logged in.
  loggedIn(state) {
    return !!state.currentUser;
  },
};

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  // eslint-disable-next-line no-unused-vars
  init({ state, dispatch }) {
    dispatch("validate");
  },

  // Logs in the current user.
  logIn({ commit, dispatch, getters }, { email, password } = {}) {
    if (getters.loggedIn) return dispatch("validate");

    return getFirebaseBackend()
      .loginUser(email, password)
      .then((response) => {
        const user = response;
        commit("SET_CURRENT_USER", user);
        return user;
      });
  },

  // Logs out the current user.
  logOut({ commit }) {
    commit('CLEAR_AUTH');
    // eslint-disable-next-line
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line no-unused-vars
      getFirebaseBackend()
        .logout()
        .then((response) => {
          console.log(response);
          resolve(true);
        })
        .catch((error) => {
          // Even if backend logout fails, we've cleared local state
          console.error('Logout error:', error);
          resolve(true);
        });
    });
  },

  // register the user
  register({ commit, dispatch, getters }, { username, email, password } = {}) {
    if (getters.loggedIn) return dispatch("validate");

    return getFirebaseBackend()
      .registerUser(username, email, password)
      .then((response) => {
        const user = response;
        commit("SET_CURRENT_USER", user);
        return user;
      });
  },

  // register the user
  // eslint-disable-next-line no-unused-vars
  resetPassword({ commit, dispatch, getters }, { email } = {}) {
    if (getters.loggedIn) return dispatch("validate");

    return getFirebaseBackend()
      .forgetPassword(email)
      .then((response) => {
        const message = response.data;
        return message;
      });
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // eslint-disable-next-line no-unused-vars
  async validate({ commit, state, dispatch }) {
    if (!state.currentUser || !state.token) return Promise.resolve(null);
    
    try {
      // Validate token with backend
      const response = await fetch(`${process.env.VUE_APP_API_URL}/me`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${state.token}`,
          'Content-Type': 'application/json'
        },
        credentials: 'include'
      });

      const data = await response.json();

      if (!data.valid) {
        // Token is invalid or expired
        console.warn('Token validation failed:', data.message);
        commit('CLEAR_AUTH');
        return null;
      }

      // Update user data
      commit('SET_CURRENT_USER', data.user);
      return data.user;
    } catch (error) {
      console.error('Token validation error:', error);
      commit('CLEAR_AUTH');
      return null;
    }
  },
};

// ===
// Private helpers
// ===

// function saveState(key, state) {
//   window.sessionStorage.setItem(key, JSON.stringify(state));
// }
